import { referralExportRetryResponseSchema } from "@/src/models/referral-export-retry";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function retryReferralExport(taskId: string) {
  return referralExportRetryResponseSchema.parse(
    await fetchJSON(`/api/tasks/${taskId}/retry-referral-export`, { method: "POST" })
  );
}
